import { registerHandler, Sha256Email } from "../handler";

declare const snaptr: any;

let snapInitEmail: string;

function initSnap(email: Sha256Email) {
  if (email && snapInitEmail !== email) {
    snaptr("init", "e030eb4f-d3fd-4c13-9338-9c0a3b6847ad", {
      user_email: email,
    });
    snapInitEmail = email;
  }
}

export default function registerHandlers() {
  registerHandler("lead", ({ emailHashes }) => {
    initSnap(emailHashes.sha256);

    snaptr("track", "SIGN_UP", { value: "healthy-weight" });
  });

  registerHandler("purchase", ({ emailHashes, order, plan }) => {
    initSnap(emailHashes.sha256);

    snaptr("track", "PURCHASE", {
      order_value: order.eltv_13_months,
      currency: plan.currency || "USD",
      transaction_id: order.subscriptionId,
      price: order.eltv_13_months,
    });
  });
}
